(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FormulaDeleteController',FormulaDeleteController);

    FormulaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Formula'];

    function FormulaDeleteController($uibModalInstance, entity, Formula) {
        var vm = this;

        vm.formula = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Formula.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
